//===================================
// Splide helpers
//===================================

import { observeWhenInView } from '../utils';

/**
 * Splide Gallery factory
 * 
 * @param {string} className 
 * @param {object} settings 
 */
export function SplideGallery(className, settings) {
  /**
   * New instance of gallery
   * 
   * @param {HTMLElement} ele 
   */
  const instance = (ele) => {
    /**
     * Check if Splide ele is in view
     * 
     * @param {bool} inView 
     * @param {function} unobserve 
     * @returns {null}
     */
    const checkInView = (inView, unobserve) => {
      if (!inView) return;
    
      unobserve();
      init();
    }

    /**
     * Gallery init
     * 
     * @returns {null}
     */
    const init = async () => {
      const res = await import('@splidejs/splide');
      const Splide = res?.Splide;

      if (!Splide) return;

      const splideInstance = new Splide(ele, settings);
      splideInstance.mount();
    }

    observeWhenInView(ele, checkInView, {rootMargin: '50% 0% 50% 0%'});
  }

  /**
   * On window load init galleries.
   * 
   */
  window.addEventListener('load', function() {
    const galleries = document.querySelectorAll(className);
      
    galleries.forEach(ele => instance(ele));
  });
}